import {
  QUERY_RESPONSE_RECEIVED,
  MUTATION_RESPONSE_RECEIVED,
} from '@web-platform/shared-universal-constants/src/network';
import {
  SONAR_V3_ALPHA_CREATE_SESSION,
  SONAR_V3_CREATE_SESSION,
  SONAR_V3_POLL,
  SONAR_V3_POLL_ALPHA,
} from '@web-platform/shared-universal-types/src/network/requestTypes';
import { isSonarV3ErrorPayload } from '@web-platform/shared-universal-utils-frontend/src/helpers/isSonarErrorPayload';
import keyBy from 'lodash/keyBy';

import { isEmptyItinerary, isNullishItinerary } from '../utils';

import { mapSonarV3Legs } from './sonarV3LegsMapper';

import type {
  MutationAction,
  QueryAction,
} from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';
import type { LegStateBookingPanel } from '@web-platform/shared-universal-types/src/redux/state/shared/flightBookingPanel/entities/flights/legsBookingPanel';

export const INITIAL_STATE: LegStateBookingPanel = {
  byId: {},
};

const legsReducer = (
  state: LegStateBookingPanel = INITIAL_STATE,
  action: MutationAction | QueryAction,
): LegStateBookingPanel => {
  switch (action.type) {
    case MUTATION_RESPONSE_RECEIVED:
    case QUERY_RESPONSE_RECEIVED: {
      if (
        action.payload.type === SONAR_V3_CREATE_SESSION ||
        action.payload.type === SONAR_V3_ALPHA_CREATE_SESSION ||
        action.payload.type === SONAR_V3_POLL ||
        action.payload.type === SONAR_V3_POLL_ALPHA
      ) {
        if (isSonarV3ErrorPayload(action.payload.response)) {
          return state;
        }
        if (
          isEmptyItinerary(action.payload.response) ||
          isNullishItinerary(action.payload.response)
        ) {
          return state;
        }

        const legs = mapSonarV3Legs(action.payload.response.body.itinerary?.legs);

        return {
          byId: { ...state.byId, ...keyBy(legs, (leg) => leg.id) },
        };
      }

      return state;
    }

    default:
      return state;
  }
};

export default legsReducer;
